import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import DataGrid, {
    Column,
    ColumnChooser,
    Paging,
    Scrolling,
    Export,
    Summary,
    TotalItem,
    GroupPanel,
    Grouping,
    GroupItem
} from 'devextreme-react/data-grid';
import Request from "../../components/api/Request";
import { Button } from 'devextreme-react/button';
import 'devextreme/data/odata/store';
import CustomStore from 'devextreme/data/custom_store';
import DropDownBox from 'devextreme-react/drop-down-box';
import TreeView from 'devextreme-react/tree-view';
import { Popup } from 'devextreme-react/popup';
import { showToast } from "../../utils/Utils";
import { ToastType } from "../../constants/Constants";
import TesvikFarkRaporDetay from '../tesvikraporfark/TesvikFarkRaporDetay';
import { parseDate ,hasRole} from "../../utils/Utils";
import './AsgariUcretRaporFark.scss';
//import ExcelJS from 'exceljs';
//import saveAs from 'file-saver';
/*
  // Use this import for codeSandBox
  import FileSaver from "file-saver";
*/
import { exportDataGrid } from 'devextreme/excel_exporter';


const AsgariUcretRaporFark = (props) => {

    const dispatch = useDispatch();
 

    const listeBasligi = "Asgari Ücret Rapor Fark";
    const [store, setStore] = useState(null); 

    const [treeBoxValue, setTreeBoxValue] = useState([]);
    const [treeDataSource, setTreeDataSource] = useState([]);

    const [treeBoxDonemValue, setTreeBoxDonemValue] = useState([]);
    const [treeDataDonemSource, setTreeDataDonemSource] = useState([]);

    useEffect(() => {
        domainListYukle();
        donemListYukle();
        setStore(new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {

                return []
            }
        }));
    }, [])

    const domainListYukle = () => {

        const request = new Request("/userDomain/getUserDomainList", "GET");

        request.run()
            .then(response => {
                if (response.data) {
                    setTreeDataSource(response.data.data);
                } else {
                    return []

                }
            });
    }
    const donemListYukle = () => {

        const request = new Request("/donem/getKayitList", "GET");

        request.run()
            .then(response => {
                if (response.data) {
                    response.data.data.map(d => {
                        d.tarih = parseDate(d.tarih);
                    });
                    let datas = [];
                    let simdi = new Date();
                    response.data.data.map(d => {
                        if (d.tarih.getTime() < simdi.getTime() && d.donemYil >=2016 ) {
                            datas.push(d);
                        }
                    });
                    // datas.sort((a,b) =>
                    //     a.tarih.getTime() - b.tarih.getTime()
                    // ).reverse();
                    // debugger;
                    let yils = [];
                    let yilDatas = [];
                    datas.map(d => {
                        let parentYil = parseInt(d.donem.substring(0, 4)) * -1;
                        d.parentid = parentYil;
                        if (yils.indexOf(parentYil) == -1) {
                            yils.push(parentYil);
                            let donemTmp = (parentYil * -1).toString();


                            yilDatas.push({ donem: donemTmp, id: parentYil, parentid: 0 });
                        }
                    });
                    yilDatas.map(d => {
                        datas.push(d);
                    });

                    setTreeDataDonemSource(datas);
                } else {
                    return []
                }
            });
    }

    let dataGrid = null;
    let treeView = null;
    let treeViewDonem = null;


    const getStore = () => {

        return new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {

                //
                // const request = new Request("/tesvikRaporIslemleri/getKayitListByDonemFark/"+ props.data.domainId  +"/1" , "GET");

                let donems = treeBoxDonemValue;

                let donemsTemp = [];
                donems.map(d => {
                    if (d > 0) {
                        donemsTemp.push(d);
                    }
                });
                let data = {};
                data.donemList = donemsTemp;
                data.domainIdList = treeBoxValue;
               

                const request = new Request("/domain-mufredat-karti-detay/getKayitList", "POST", data);
                return request.run()
                    .then(response => {

                        if (response.data) {

                            let id = 1;
                            response.data.data.map(d => { 
                                d.id = id;
                                id++; 
                            });
                            return {
                                data: response.data.data,
                                totalCount: response.data.total,
                                summary: 0,
                                groupCount: 0
                            };
                        } else {
                            return []

                        }
                    });
            }
        });
    }
    const yenile = () => {


        let domains = treeBoxValue;
        let donems = treeBoxDonemValue;

        let donemsTemp = [];
        let simdi = new Date();
        donems.map(d => {
            if (d > 0) {
                donemsTemp.push(d);
            }
        });
        if (donems.length == 0) {
            showToast('Dönem Seçiniz', ToastType.ERROR, 500);
            return;
        }
        if (domains.length == 0) {
            showToast('Firma Seçiniz', ToastType.ERROR, 500);
            return;
        }
        // if (domains.length > 40) {
        //     showToast('Hesaplanacak Firma sayısı 40 dan büyük olamaz', ToastType.ERROR, 500);
        //     return;
        // }
        if (donemsTemp.length > 120) {
            showToast('Hesaplanacak Dönem sayısı 120 ten fazla olamaz', ToastType.ERROR, 500);
            return;
        }

        setStore(getStore());
    }

    const syncTreeViewSelection = (e) => {
        let tree = (e.component.selectItem && e.component) || (treeView && treeView.instance);

        if (tree) {
            if (e.value === null) {
                tree.unselectAll();
            } else {
                let values = e.value || treeBoxValue;
                values && values.forEach(function (value) {
                    tree.selectItem(value);
                });
            }
        }

        if (e.value !== undefined) {
            if (e.value == null) {
                setTreeBoxValue([]);
            } else {
                setTreeBoxValue(e.value);
            }
        }
    }

    const treeView_itemSelectionChanged = (e) => {
        setTreeBoxValue(e.component.getSelectedNodeKeys());
    }

    const treeViewRender = () => {
        return (
            <TreeView dataSource={treeDataSource}
                ref={(ref) => treeView = ref}
                dataStructure="plain"
                keyExpr="id"
                parentIdExpr="parent.id"
                selectionMode="multiple"
                showCheckBoxesMode="normal"
                selectNodesRecursive={true}
                displayExpr="name"
                selectByClick={true}
                onContentReady={syncTreeViewSelection}
                onItemSelectionChanged={treeView_itemSelectionChanged}
                searchMode={'contains'}
                searchEnabled={true}
            />
        );
    }


    const syncTreeViewDonemSelection = (e) => {
        let tree = (e.component.selectItem && e.component) || (treeViewDonem && treeViewDonem.instance);

        if (tree) {
            if (e.value === null) {
                tree.unselectAll();
            } else {
                let values = e.value || treeBoxDonemValue;
                values && values.forEach(function (value) {
                    tree.selectItem(value);
                });
            }
        }

        if (e.value !== undefined) {
            if (e.value == null) {
                setTreeBoxDonemValue([]);
            } else {
                setTreeBoxDonemValue(e.value);
            }
        }
    }

    const treeViewDonem_itemSelectionChanged = (e) => {
        setTreeBoxDonemValue(e.component.getSelectedNodeKeys());
    }

    const treeViewDonemRender = () => {
        return (
            <TreeView dataSource={treeDataDonemSource}
                ref={(ref) => treeViewDonem = ref}
                dataStructure="plain"
                keyExpr="id"
                parentIdExpr="parentid"
                selectionMode="multiple"
                showCheckBoxesMode="normal"
                selectNodesRecursive={true}
                displayExpr="donem"
                selectByClick={true}
                onContentReady={syncTreeViewDonemSelection}
                onItemSelectionChanged={treeViewDonem_itemSelectionChanged}
            />
        );
    }


    function siraRender(data) {
        return (data.rowIndex + 1);// <b>{(data.rowIndex +1)}</b> ;
    } 

    function onExporting(e) {

        debugger;
        let fileName = "";
        treeDataSource.map(sd => {
            if (treeBoxValue.indexOf(sd.id) > -1 && sd.sicilNo != null && sd.sicilNo != "") {
                fileName += sd.name;

            }
        });

        if (fileName == "") {
            fileName = "RaporFark";
        }
        fileName = fileName.substring(0, 100);


        
        
        e.fileName = fileName;

        //e.cancel = true;
    } 

    function madenBelgeTuruHesaplandiStyle(data) {

        if( data.row.data.madenBelgeTuruHesaplandi){
         //return   <div style={{backgroundColor:  '#5C95C5'}}>{data.value}</div>
         //return  <div style={{backgroundColor:  '#5C95C5'}}> <b>{data.value}</b></div>
        //  if(!data.component.isRowSelected(data.rowIndex)){
            //  data.cellElement.style.backgroundColor ='#5C95C5'
             return  <div style={{backgroundColor:  '#F6BB42', margin:0}}> <b>{data.value}</b></div>
         // }

        }
        return data.value;
    }

    return (
        <div >
            {/* <h2 className={'dx-icon-product'}>{listeBasligi}</h2>
            <div className="dx-field">
                <div className="buttons" align={'left'} style={{marginLeft: "10px"}}>
                </div>
            </div> */}


            <h2 className={'dx-icon-product'} >{listeBasligi}</h2>
            <div className="dx-field">
                <div className="buttons" align={'left'} style={{ marginLeft: "10px" }}>
                    <DropDownBox
                        value={treeBoxValue}
                        valueExpr="id"
                        displayExpr="name"
                        placeholder="Firma Seçiniz..."
                        showClearButton={true}
                        dataSource={treeDataSource}
                        onValueChanged={syncTreeViewSelection}
                        contentRender={treeViewRender}
                        width="500"
                    />
                    <DropDownBox
                        value={treeBoxDonemValue}
                        valueExpr="id"
                        displayExpr="donem"
                        placeholder="Dönem Seçiniz..."
                        showClearButton={true}
                        dataSource={treeDataDonemSource}
                        onValueChanged={syncTreeViewDonemSelection}
                        contentRender={treeViewDonemRender}
                        width="500"
                    />
                    <Button icon="plus" width={150} text="Yenile" type={'success'} style={{ fontSize: "15px" }}
                        onClick={yenile}></Button>
                </div>
            </div>

            <DataGrid
                className="tesvikRaporFarkListesiGrid"
                ref={ref => dataGrid = ref}
                width="100%"
                //height="500px"
                dataSource={store}
                key="id"
                keyExpr="id"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                //defaultFocusedRowIndex={0}
                columnAutoWidth={false}
                //columnHidingEnabled={true}
                //onToolbarPreparing={onToolbarPreparing}
                selection={{ mode: 'single', deferred: true }}
                onExporting={onExporting} 
            //remoteOperations={true}
            >
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={true} />
                {/* <SearchPanel visible={true} /> */}
                {/* <FilterRow visible={true} /> */}
                <Export enabled={true} />
                <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."} />
                <Scrolling columnRenderingMode="virtual" showScrollbar="always" />
                <Paging enabled={false} />

                {/* <Pager showPageSizeSelector={true} allowedPageSizes={[5, 10, 20, 50, 100, 200]} showInfo={true}  visible={true} />
                <Paging defaultPageSize={10} /> */}

                <Column width={30} caption={'Sıra'} dataType="number" visible={true} cellRender={siraRender} />
                <Column dataField={'id'} width={90} caption={'Id'} dataType="number" visible={false} />
                <Column dataField={'domainName'} width={200} caption={'Firma'} dataType="string" visible={true} groupIndex={0} />
                <Column dataField={'yil'} width={50} caption={'Yıl'} dataType="number" visible={true} defaultSortOrder="desc" groupIndex={0} />
                
                <Column dataField={'yil'} width={50} caption={'Yıl'} dataType="number" visible={true} defaultSortOrder="desc" />
                <Column dataField={'ay'} width={50} caption={'Ay'} dataType="number" visible={true}  defaultSortOrder="asc" />
                <Column dataField={'cariYilGunSayisi'} width={100} caption={'Faydalanılan Gün Sayısı'} dataType="number" visible={true}  />
                <Column dataField={'cariYilDestekTutari'} width={100} caption={'Destek Tutarı'} dataType="number" visible={true}  />
                <Column dataField={'cariYilTahsilatTarihi'} width={100} caption={'Tahsilat Tarihi'} dataType="date"  format="yyyy/MM" visible={true}  />
                <Column dataField={'cariYilSigortaliSayi'} width={100} caption={'İstihdam Şartı'} dataType="number"   visible={true}  />


                <Column dataField={'cariDonemIstihdamSayi'} width={100} caption={'Cari dönem istihdam sayısı (emekli hariç)'} dataType="number"   visible={true}  />
                <Column dataField={'cariDonemGunSayi0Sayi'} width={100} caption={'Cari Ay Günü "0" Olan Kişi Sayısı'} dataType="number"   visible={true}  />
                <Column dataField={'cariDonemGunSayi'} width={100} caption={'Cari Gün'} dataType="number"   visible={true}  />

                <Column dataField={'oncekiDonemAgiDestekLimiti1GunSayi'} width={100} caption={'Önceki Yıl Limit1 altı'} dataType="number"   visible={true}  />
                <Column dataField={'oncekiDonemAgiDestekLimiti2GunSayi'} width={100} caption={'Önceki Yıl Limit2 altı'} dataType="number"   visible={true}  />
                <Column dataField={'oncekiDonemAgiDestekLimiti3GunSayi'} width={100} caption={'Önceki Yıl Limit3 altı'} dataType="number"   visible={true}  />


                <Column dataField={'cariDonemGunSayisiTutari'} width={100} caption={'Cari Dönem Gün Sayısı * Limit1 Tutar'} dataType="number"   visible={true}  />
                <Column dataField={'oncekiDonemAgiDestekLimiti1GunSayiTutari'} width={100} caption={'Bir önceki yıl aynı dönem Günlük Ücreti Limit1 TL ye kadar gün sayısı*Limit Çarpan'} dataType="number"   visible={true}  />
                <Column dataField={'oncekiDonemAgiDestekLimiti2GunSayiTutari'} width={100} caption={'Bir önceki yıl aynı dönem Günlük Ücreti Limit2 TL ye kadar gün sayısı*Limit Çarpan'} dataType="number"   visible={true}  />
                <Column dataField={'oncekiDonemAgiDestekLimiti3GunSayiTutari'} width={100} caption={'Bir önceki yıl aynı dönem Günlük Ücreti Limit3 TL ye kadar gün sayısı*Limit Çarpan'} dataType="number"   visible={true}  />
          

                <Column dataField={'cariFark'} width={100} caption={'Cari  Fark TL.'} dataType="number" visible={true} /> 
                <Column dataField={'kategori1Fark'} width={100} caption={'Kategori 1'} dataType="number" visible={true} /> 
                <Column dataField={'kategori2Fark'} width={100} caption={'Kategori 2'} dataType="number" visible={true} /> 
                <Column dataField={'kategori3Fark'} width={100} caption={'Kategori 3'} dataType="number" visible={true} /> 



                <Column dataField={'fark1'} width={100} caption={'Fark 1'} dataType="number" visible={true} /> 
                <Column dataField={'fark2'} width={100} caption={'Fark 2'} dataType="number" visible={true} /> 
                <Column dataField={'fark3'} width={100} caption={'Fark 3'} dataType="number" visible={true} cellRender={madenBelgeTuruHesaplandiStyle} /> 

 
                {/* <Column dataField={'fark'} width={100} caption={'Fark'} dataType="number" visible={true} />  */}

                 <Column dataField={'mesaj'} width={500} caption={'Dönem mesaj'} dataType="string" visible={true} />

                <Column dataField={'asgariDestekBasTarih'} width={100} caption={'TİS Başlama'} dataType="date"  format="yyyy/MM/dd" visible={true} /> 
                <Column dataField={'asgariDestekBitTarih'} width={100} caption={'TİS Bitiş'} dataType="date"    format="yyyy/MM/dd" visible={true} /> 
 
              
                <Column dataField={'cariDonemAgiDestekLimiti1Tutari'} width={100} caption={'Limit1 Tutar'} dataType="number"   visible={false}  />
                <Column dataField={'cariDonemAgiDestekLimiti2Tutari'} width={100} caption={'Limit2 Tutar'} dataType="number"   visible={false}  />
                <Column dataField={'cariDonemAgiDestekLimiti3Tutari'} width={100} caption={'Limit3 Tutar'} dataType="number"   visible={false}  />
                <Column dataField={'agiDestekCarpan'} width={100} caption={'Limit Çarpan'} dataType="number"   visible={false}  />

 
                <Summary>
                    <GroupItem
                        column="danismanTutar"
                        summaryType="sum"
                        valueFormat="decimal"
                        showInGroupFooter={true}
                        alignByColumn={true}
                        displayFormat="Toplam: {0} TL" />

                    <GroupItem
                        column="firmaTutar"
                        summaryType="sum"
                        valueFormat="decimal"
                        showInGroupFooter={true}
                        alignByColumn={true}
                        displayFormat="Toplam: {0} TL" />

                    <GroupItem
                        column="fark"
                        summaryType="sum"
                        valueFormat="decimal"
                        showInGroupFooter={true}
                        alignByColumn={true}
                        displayFormat="Toplam: {0} TL" />
                    <TotalItem
                        column="cvLikTutar"
                        summaryType="sum"
                        valueFormat="decimal"
                        displayFormat="Toplam: {0} TL" />
                    <TotalItem
                        column="firmaTutar"
                        summaryType="sum"
                        valueFormat="decimal"
                        displayFormat="Toplam: {0} TL" />
                    <TotalItem
                        column="fark"
                        summaryType="sum"
                        valueFormat="decimal"
                        displayFormat="Toplam: {0} TL" />
                </Summary>

            </DataGrid>
 
        </div>
    )
}

export default AsgariUcretRaporFark;
